export default {
  "welcome": {
    "welcome-to": "مرحبًا بك في",
    "one-philly": "ون فيلي،",
    "united-city": "مدينة موحدة!",
  },
  "city-offices": {
    "city-offices-title": "مكاتب المدينة",
    "city-offices-text-1": "مكاتب المدينة مفتوحة لساعات العمل العادية. يتم تقديم بعض الخدمات عبر الإنترنت أو عن طريق تحديد موعد. لمعرفة المزيد، ",
    "city-offices-text-2": "تحقق مع قسم الاهتمام الخاص بك.",
    "city-offices-closure-text": "",
    "trash-title": "القمامة وإعادة التدوير",
    "trash-text-1": "مجموعات القمامة وإعادة التدوير مدرجة في جدول العطلات. قم بإعداد المواد بعد يوم واحد من يومك العادي.",
    "trash-text-2": "لمعرفة المزيد، ",
    "trash-text-3": "تحقق من جدول العطلات.",
    "trash-closure-text": "",
  },
  "services": {
    "trash": "ابحث عن يوم القمامة الخاص بك",
    "bill": "دفع فاتورة",
    "jobs": "اكتشف وظائف المدينة",
    "property": "ابحث عن عقار",
    "taxes": "قم بتقديم ودفع ضرائب المدينة",
    "recycle": "أعد تدوير أوراق الخريف",
    "visit": "قم بزيارة شخص مسجون",
    "license": "احصل على ترخيص",
    "popular-services": "خدمات شعبية",
    "jump-to-all-services": "انتقل إلى جميع الخدمات",
    "services-by-topic": "الخدمات حسب الموضوع",
    "see-all-services": "شاهد جميع الخدمات",
    "alerts": "اشترك للحصول على تنبيهات الطوارئ",
  },
  "tools": {
    "parks-finder": "مكتشف الحدائق والاستجمام",
    "contracts": "مركز العقود",
    "school-time-activity": "أداة البحث عن الأنشطة خارج المدرسة",
    "food-meal": "أداة البحث عن الطعام والوجبات المجانية",
    "atlas": "أطلس",
    "primary": "مكتشف الرعاية الأولية",
    "eclipse": "كسوف",
    "mail-vote-remind": "إرسال تذكير بالتصويت عبر البريد",
    "street-smart": "ستريت سمارتفيل",
    "commonly-used-tools": "أدوات شائعة الاستخدام",
    "see-all-tools": "شاهد جميع الأدوات",
  },
  "news": {
    "featured-news": "أخبار مميزة",
    "see-all-news": "شاهد جميع الأخبار",
  },
  "311": {
    "report-311": "ساعد في جعل فيلادلفيا المدينة الكبيرة الأكثر أمانًا ونظافة وخضرة في البلاد. قم بالإبلاغ عن قطع الأراضي الشاغرة والجرافيتي والسيارات المهجورة والمزيد إلى Philly311.",
    "report-problem": "الإبلاغ عن مشكلة",
    "track-request": "تتبع الطلب",
    "ask-question": "طرح سؤال",
  },
  "stay-connected": {
    "stay-connected": "ابق على اتصال",
    "sign-up-email": "اشترك للحصول على تحديثات البريد الإلكتروني من مدينة فيلادلفيا",
    "sign-up": "قم بالتسجيل",
  },
  "footer": {
    "elected-officials": "المسؤولون المنتخبون",
    "mayor": "عمدة",
    "city-council": "مجلس المدينة",
    "courts": "المحاكم",
    "district-attorney": "محامي المقاطعة",
    "city-controller": "سيتي كونترولر",
    "sheriff": "شريف",
    "city-commissioners": "مفوضو المدينة",
    "register-wills": "سجل الوصايا",
    "open-govt": "الحكومة المفتوحة",
    "code-charter": "كود وميثاق فيلادلفيا",
    "city-records": "سجلات المدينة",
    "city-agency-regs": "لوائح وكالة المدينة",
    "executive-orders": "أوامر تنفيذية",
    "honesty-govt": "الصدق في الحكومة",
    "voting-elections": "التصويت والانتخابات",
    "open-data": "البيانات المفتوحة",
    "org-chart": "مخطط تنظيم المدينة",
    "explore-phila": "اكتشف فيلادلفيا",
    "visit-phila": "قم بزيارة فيلادلفيا",
  },
  "clean-green": {
    "clean-green": "نظيف وأخضر ",
    "clean-green-statement": "تتحد مدينتنا معًا لجعل فيلي المدينة الكبيرة الأكثر أمانًا ونظافة وخضرة في البلاد، مع توفير فرص اقتصادية للجميع. اتبع الإستراتيجية على مستوى المدينة التي تعالج قضايا جودة الحياة في كل حي.",
    "blocks-swept": "اكتسحت الكتل",
    "abandoned-autos": "تمت إزالة السيارات المهجورة",
    "properties-cleaned": "تم تنظيف الخصائص وختمها",
    "graffiti-removed": "تمت إزالة الكتابة على الجدران",
    "see-all-clean-green": "شاهد كل ما هو نظيف وأخضر",
  },
  "mayor": {
    "mayor-details": "Cherelle L. Parker هي العمدة المائة لفيلادلفيا وأول امرأة تشغل هذا المنصب منذ 341 عامًا. إنها مقيمة مدى الحياة في المدينة، وهي ملتزمة بالقتال كل يوم من أجل سكان فيلادلفيا.",
    "learn-more": "تعرف على المزيد",
  },
  "city-council": {
    "city-council": "مجلس المدينة",
    "district-council-member": "عضو مجلس المقاطعة",
    "council-member-al":  "عضو المجلس العام",
    "council-president": "رئيس المجلس",
    "dep-majority-whip": "سوط نائب الأغلبية",
    "majority-whip": "سوط الأغلبية",
    "minority-leader": "زعيم الأقلية",
    "minority-whip": "سوط الأقلية",
    "majority-leader": "زعيم الأغلبية",
  }, 
  "philly-stat-360": {
    "ps360": "فيلادلفيا ستارت 360",
    "data-subheader": "تحويل البيانات إلى إجراءات لمجتمعاتنا.",
  },
};